<template>
	<b-modal ref="ModalEditCentre">
		<template slot="modal-header" slot-scope="{ close }">
			<i class="btn btn-link my-auto" @click="close()"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /></i>
			<h2 class="mx-auto my-auto">{{ $t('action.modifier_centre') }}</h2>
		</template>
		<template slot="default">
			<div class="form-group">
				<label>{{ $t('monte.reservation.centre_stockage') }}</label>
				<b-form-checkbox id="expediteur_modify" v-model="expediteur_modify">
					<label for="expediteur_modify">{{ $t("global.modifier") }}</label>
				</b-form-checkbox>
				<e-select
					:disabled="!expediteur_modify"
					v-model="expediteur"
					id="expediteur"
					track-by="tiers_id"
					label="tiers_rs"
					:placeholder="$t('monte.reservation.choisir_centre_stockage')"
					:selectedLabel="$t('global.selected_label')"
					:options="available_tiers"
					:show-labels="false"
				></e-select>
			</div>

			<label>{{ $t('monte.reservation.echeance') }}</label>
			<b-form-checkbox id="delivery_date_modify" v-model="delivery_date_modify">
				<label for="delivery_date_modify">{{ $t("global.modifier") }}</label>
			</b-form-checkbox>
			<e-datepicker v-model="delivery_date" :disabled="!delivery_date_modify" />
			<template v-if="checkRoute">
				<template v-if="checkRouteDelivered">
					<label>{{ $t('monte.reservation.delivery_date') }}</label>
					<b-form-checkbox id="order_delivery_date_modify" v-model="order_delivery_date_modify">
						<label for="order_delivery_date_modify">{{ $t("global.modifier") }}</label>
					</b-form-checkbox>
					<e-datepicker v-model="order_delivery_date" :disabled="!order_delivery_date_modify" />
				</template>
				<label>{{ $t('monte.reservation.shipping_date') }}</label>
				<b-form-checkbox id="shipping_date_modify" v-model="shipping_date_modify">
					<label for="shipping_date_modify">{{ $t("global.modifier") }}</label>
				</b-form-checkbox>
				<e-datepicker v-model="shipping_date" :disabled="!shipping_date_modify" />
			</template>
		</template>

		<template slot="modal-footer" class="justify-content-center">
			<b-button variant="primary" @click="submitModal()" :disabled="processing">
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
				{{ $t('global.sauvegarder') }}
			</b-button>
		</template>
	</b-modal>
</template>

<script type="text/javascript">
	import _cloneDeep from 'lodash/cloneDeep'
	import MonteReservationOrder from "@/mixins/MonteReservationOrder.js"

	export default {
		name: 'ModalEditCentre',
		mixins: [MonteReservationOrder],
		props: {
			available_tiers: { type: Array, default: () => [] },
			reservation_order: { type: Array, default: () => [] },
			tableId: { type: String, default: null }
		},
		data () {
			return {
				processing: false,
				expediteur: null,
				delivery_date: null,
				delivery_date_modify: false,
				shipping_date: null,
				shipping_date_modify: false,
				order_delivery_date: null,
				order_delivery_date_modify: false,
				expediteur_modify: false
			}
		},
		methods: {
			prepareModal() {
				if(!this.reservation_order) return
				this.resetModal()
				
				this.expediteur = this.reservation_order[0].expediteur
				if(this.reservation_order.length == 1) {
					if(this.reservation_order[0].delivery_date) {this.delivery_date = new Date(this.reservation_order[0].delivery_date)}
					if(this.reservation_order[0].order.expedition_date) {this.shipping_date = new Date(this.reservation_order[0].order.expedition_date)}
					if(this.reservation_order[0].order.delivery_date) {this.order_delivery_date = new Date(this.reservation_order[0].order.delivery_date)}
				}
			},
			openModal() {
				this.$refs.ModalEditCentre.show()
			},
			closeModal() {
				this.$refs.ModalEditCentre.hide()
			},
			resetModal() {
				this.expediteur = null
				this.delivery_date = null
				this.delivery_date_modify = false
				this.shipping_date = null
				this.shipping_date_modify = false
				this.order_delivery_date = null
				this.order_delivery_date_modify = false
				this.expediteur_modify = false
			},
			async submitModal() {
				this.processing = true;
				if(this.delivery_date_modify || this.expediteur_modify || this.shipping_date_modify || this.order_delivery_date_modify) {
					const date = this.delivery_date_modify ? this.delivery_date.toDateInputValue() : null
					const shipping_date = this.shipping_date_modify ? this.shipping_date.toDateInputValue() : null
					const order_delivery_date = this.order_delivery_date_modify ? this.order_delivery_date.toDateInputValue() : null
					this.expediteur.tiers_id = this.expediteur_modify ? this.expediteur.tiers_id : null
					const ids = this.reservation_order.map(r => r.id)
					await this.editExpediteurAndDate(ids, this.expediteur.tiers_id, date, shipping_date, order_delivery_date)
				}
				this.processing = false
				this.$emit('ok')
				this.closeModal()
			}
		},

		computed: {
			checkRoute() {
				return ['monte_resa_suivi', 'monte_resa_delivered', 'monte_resa_not_delivered'].includes(this.tableId)
			},
			checkRouteDelivered() {
				return ['monte_resa_delivered'].includes(this.tableId)
			}
		},

		watch: {
			reservation_order() {
				this.prepareModal()
			}
		}
	}

</script>